
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { Plus, Users, ChevronRight, GraduationCap, Calendar, UserCog } from 'lucide-react';

const QuickActions = () => {
  return (
    <Card className="card-glow-intense">
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common tasks you can perform</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Link to="/students/new" className="block">
          <Button variant="outline" className="w-full justify-between">
            <div className="flex items-center">
              <GraduationCap className="mr-2 h-4 w-4 text-nalc-teal" />
              Add New Student
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
        
        <Link to="/teachers/new" className="block">
          <Button variant="outline" className="w-full justify-between">
            <div className="flex items-center">
              <Users className="mr-2 h-4 w-4 text-nalc-blue" />
              Add New Teacher
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
        
        <Link to="/admins" className="block">
          <Button variant="outline" className="w-full justify-between">
            <div className="flex items-center">
              <UserCog className="mr-2 h-4 w-4 text-nalc-purple" />
              Add New Admin
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
        
        <Link to="/timetable/new" className="block">
          <Button variant="outline" className="w-full justify-between">
            <div className="flex items-center">
              <Calendar className="mr-2 h-4 w-4 text-nalc-purple" />
              Schedule Class
            </div>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
